//
export const ACC_CORP_LOGO_VIEW = 'ACC_CORP_LOGO_VIEW';
export const ACC_CORP_LOGO_VIEW_SUCCESS = 'ACC_CORP_LOGO_VIEW_SUCCESS';
export const ACC_CORP_LOGO_VIEW_FAIL = 'ACC_CORP_LOGO_VIEW_FAIL';
export const ACC_CORP_LOGO_VIEW_RESET = 'ACC_CORP_LOGO_VIEW_RESET';
export const ACC_CORP_LOGO_VIEW_REFRESH = 'ACC_CORP_LOGO_VIEW_REFRESH';
